export default "__VITE_ASSET__Bc0pJMLj__"